import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/vinted-feedback';

export default function Example() {
  return (
    <>
      <Head>
        <title>Vinted Guide: How to Handle Vinted Feedback Like a Pro</title>
        <meta
          name='description'
          content="Information provided by customers, whether good or bad, will generally affect how businesses run. Here's how you can get the most out of Vinted feedback and utilize it to your advantage!"
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/vinted-feedback' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/vinted-feedback' />
        <meta property='og:title' content='Vinted Guide: How to Handle Vinted Feedback Like a Pro' />
        <meta
          property='og:description'
          content="Information provided by customers, whether good or bad, will generally affect how businesses run. Here's how you can get the most out of Vinted feedback and utilize it to your advantage!"
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-10-20T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-10-20T00:00:00-00:00' />
        <meta property='article:tag' content='Vinted' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
